<ng-select #SelectContractCard [items]="items"  bindValue="id" bindLabel="name" [ngModel]="contractCardIds" [multiple]="true" (ngModelChange)="onContractCardChange($event)" [searchable]="true" placeholder="Search contract card">
    <ng-template ng-header-tmp>
        <input class="form-control w-100" type="text" (input)="onSearchChanged($event.target.value)" />
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
        <span [ngClass]="{'potential-match': (preselectedIds | idIncluded: item.id) }">
            {{ item.name }}
        </span>
    </ng-template>
    
</ng-select>
